import React from 'react';

export const IntegrationsSkeleton = () => {
  return (
    <div className='px-4 md:px-0'>
      <div className='flex justify-center'>
        <div className='w-full md:w-[850px]'>
          {/* Back button skeleton */}
          <div className='rounded-full mb-4 md:mb-6 h-10 w-10 bg-tertiary animate-pulse' />
        </div>
      </div>
      <div className='flex justify-center'>
        <div className='flex justify-start w-full max-w-[630px] flex-col mb-5 md:mb-40'>
          {/* Header section skeleton */}
          <header className='pb-12'>
            <div className='flex items-center mx-auto flex-col gap-y-3 text-center'>
              {/* Avatar skeleton */}
              <div className='overflow-hidden w-[100px] h-[100px] rounded-lg bg-tertiary animate-pulse' />

              {/* Title/subtitle skeleton */}
              <div className='flex flex-col gap-y-1 w-full items-center'>
                <div className='h-8 w-48 bg-tertiary rounded-sm animate-pulse' />
                <div className='h-6 w-36 bg-tertiary rounded-sm animate-pulse' />
              </div>
            </div>

            {/* Tabs skeleton */}
            <div className='flex justify-center items-center pt-8 pl-4 pb-0 overflow-x-auto w-full'>
              <div className='inline-block whitespace-nowrap space-x-2'>
                {[1, 2, 3].map((tab) => (
                  <div
                    key={tab}
                    className='inline-block whitespace-nowrap py-1.5 px-3 xs:py-2 xs:px-4 rounded-full bg-tertiary animate-pulse w-16'
                  />
                ))}
              </div>
            </div>
          </header>

          {/* Section content skeleton */}
          <section>
            {/* Section title */}
            <div className='h-8 w-56 bg-tertiary rounded-sm animate-pulse mb-6' />

            {/* Section subtitle */}
            <div className='h-16 w-full bg-tertiary rounded-sm animate-pulse mb-6' />

            {/* Input field skeleton */}
            <div className='grid items-start mb-4 sm:mb-8 grid-cols-1 gap-4'>
              <div>
                <div className='flex flex-row items-center mb-2'>
                  <div className='h-4 w-20 bg-tertiary rounded-sm animate-pulse' />
                </div>
                <div className='flex flex-col'>
                  <div className='relative flex items-center w-full'>
                    <div className='h-12 w-full bg-tertiary rounded-sm animate-pulse' />
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Footer skeleton */}
          <div className='flex flex-wrap fixed bottom-0 left-0 right-0 gap-3 sm:gap-6 w-full bg-primary shadow-custom p-4 md:py-6 justify-center'>
            <div className='w-full max-w-[660px] flex gap-3 sm:gap-6 justify-end'>
              <div className='h-11 w-28 bg-tertiary rounded-md animate-pulse' />
              <div className='h-11 w-28 bg-tertiary rounded-md animate-pulse' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
